import React from "react";

import AuthenticationContext, { AuthenticationContextValue } from "../contexts/AuthenticationContext";

const useAuthentication = (): AuthenticationContextValue => {
  const context = React.useContext(AuthenticationContext);
  return context || { authInfo: null, isAuthenticated: false, login: async () => {}, logout: () => {} };
};

export default useAuthentication;
